import moment from "moment-timezone";

// Pinned to Kigali rather than the viewer's own zone: a national blood system
// should show the time the staff on the ground recorded, whatever machine the
// record is being read on.
const DISPLAY_TZ = "Africa/Kigali";

// Two kinds of value arrive here. Most are instants, and reading one in UTC
// showed the wrong clock - a transfer recorded at 08:53 in Kigali displayed as
// 06:53. Some, expiredDate among them, are wall-clock strings already written
// in Kigali time; parsing those as UTC and then applying the offset pushed
// them forward instead, so an expiry of 23:59 read as 01:59 the next day.
// inputFormat is what tells the two apart, so it decides how the value is
// parsed rather than only how it is printed.
const formatDate = (dateStr, format = "ll", inputFormat = null) => {
  if (!dateStr || dateStr === "-") return "-";

  return inputFormat
    ? moment.tz(dateStr, inputFormat, DISPLAY_TZ).format(format)
    : moment(dateStr).tz(DISPLAY_TZ).format(format);
};

export default formatDate;
